var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8965 18C5.52012 18 5.69637 17.7512 5.69637 17.4332C5.69637 17.1152 5.69637 16.424 5.68278 15.4424C2.44267 16.1475 1.75127 13.8663 1.75127 13.8663C1.22253 12.5253 0.449798 12.1521 0.449798 12.1521C-0.60769 11.4332 0.531127 11.447 0.531127 11.447C1.69704 11.53 2.32066 12.6498 2.32066 12.6498C3.36455 14.447 5.04561 13.9217 5.70992 13.6175C5.76415 13.023 6.02173 12.4562 6.45555 12.0415C3.86616 11.7512 1.1412 10.742 1.1412 6.26266C1.12765 5.10139 1.56148 3.96775 2.34775 3.12445C2.21219 2.83411 1.81905 1.64517 2.44267 0.0276461C2.44267 0.0276461 3.41879 -0.290324 5.65569 1.23045C7.56723 0.705075 9.57365 0.705075 11.4852 1.23045C13.695 -0.276464 14.6847 0.0276461 14.6847 0.0276461C15.3083 1.63135 14.9151 2.8203 14.8067 3.12445C15.593 3.96775 16.0133 5.10139 15.9997 6.26266C15.9997 10.7558 13.2747 11.7373 10.6718 12.0276C11.0785 12.3733 11.4581 13.0922 11.4581 14.1843C11.4581 15.7604 11.4446 17.0046 11.4446 17.3779C11.4446 17.682 11.5801 17.9309 12.2444 17.9309L4.8965 18Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.d27d86883a60bd746f8cbed0515442c4.svg";
export { ForwardRef as ReactComponent };